import { render, staticRenderFns } from "./PageBottom.vue?vue&type=template&id=69f43815&scoped=true"
import script from "./PageBottom.vue?vue&type=script&lang=js"
export * from "./PageBottom.vue?vue&type=script&lang=js"
import style0 from "./PageBottom.vue?vue&type=style&index=0&id=69f43815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f43815",
  null
  
)

export default component.exports